// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"0a3bc1fc03aefe255693","655":"e01388d1f59d37910d1e"}[chunkId] + ".js";
};